import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import Button from "../button/button";
import useDataStore from "../../data/store/useDataStore";
import { t } from 'ttag';

const Wrapper = styled.div`
  .whiteBtn {
    background-color: #FFF;
    color: #9738FF;
  }
  .whiteBtn.active {
    background-color: #9738FF;
    color: #FFF;
    cursor: not-allowed;
  }
  input[type="text"] {
    border: 1px solid #ccc;
    padding: 8px 12px;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 8px;
  }
`;

const Label = styled.label`
  display: block;
  margin-left: 12px;
  color: #000;
  cursor: pointer;

  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 200%;
  
  background-color: #FFF;
  margin: 5px;
  padding: 5px;
  padding-left: 10px;
  border-radius: 10px;

  input {
    margin-right: 12px;
  }
  
  &.action {
    background-color: #9738FF;
    color: #FFF;
  }
  
  input[type=checkbox]:checked {
    accent-color: #9738FF;
  }
  
  select {
    width: 100%;
    padding: 6px;
    border: 0px solid;
  }
`;

const GetQuestionForm = ({id, type, items, answer = false, dontShowResetBtn, onChange}) => {

  const { saveQuestion, resetAnswer } = useDataStore();
  const [inputText, setInputText] = useState('');
  const [inputValue, setInputValue] = useState('');

  const [disabledBtn, setDisabledBtn] = useState(true);
  const [disabledInputs, setDisabledInputs] = useState(false);

  const [selectedItemIndex, setSelectedItemIndex] = useState(null);

  const [selectedCheckboxIndex, setSelectedCheckboxIndex] = useState([]);
  const [selectedRadioIndex, setSelectedRadioIndex] = useState([]);
  const [selectedButtonIndex, setSelectedButtonIndex] = useState([]);
  const [selectedDropdownIndex, setSelectedDropdownIndex] = useState('');

  useEffect(() => {
    if (type === 'textbox' && answer && answer.text) {
      setInputText(answer.text);
      setInputValue(answer.text);
    }

    const selected = [];

    if (answer && answer.id) {
      if (Array.isArray(answer.id)) {
        answer.id.forEach(el => selected.push(parseInt(el)));
      }

      if (answer.text) {
        setInputText(answer.text);
      }
    }

    if (type == 'location' || type == 'department' || type == 'dropdown') {
      setSelectedDropdownIndex(Array.isArray(selected) && selected.length === 0 ? '' : selected);
      setDisabledBtn(false );
    }

    if (type === 'checkbox') {
      setSelectedCheckboxIndex(selected);
    }

    if (type === 'radio') {
      setSelectedRadioIndex(selected);
    }

    if (type === 'button') {
      setSelectedButtonIndex(selected);
    }
  }, []);

  useEffect(() => {
    if (type == 'location' || type == 'department' || type == 'dropdown') {
      setDisabledBtn(false);
      setDisabledInputs(answer ? true : false)
    } else {
      setDisabledInputs(answer ? true : false)
    }
  }, [answer]);

  useEffect(() => {
    if (type == 'location' || type == 'department' || type == 'dropdown') {
      setDisabledBtn(false);
    } else {
      setDisabledBtn(inputValue.length ? false : true);
    }
  }, [inputValue]);

  const renderRadio = (item, index) => {
    return (
      <Label key={item.id} className={(selectedRadioIndex.includes(item.id) || selectedItemIndex === index) ? 'action' : ''}>
        <input
          type="radio"
          name={id}
          value={item.id}
          disabled={disabledInputs}
          checked={selectedRadioIndex.includes(item.id)}
          onChange={(e) => {
            setInputValue([e.target.value]);
            setInputText(item.value);
            setSelectedItemIndex(index);
          }}
        />
        {item.value}
      </Label>
    );
  };

  const renderCheckbox = (item, index) => {
    return (
      <Label key={item.id} className={selectedCheckboxIndex.includes(item.id) ? 'action' : ''}>
        <input
          type="checkbox"
          name={id}
          value={item.id}
          disabled={disabledInputs}
          checked={selectedCheckboxIndex.includes(item.id)}
          onChange={(e) => {
            const currentIndex = selectedCheckboxIndex.indexOf(item.id);

            if (currentIndex !== -1) {
              const newInputValue = selectedCheckboxIndex.filter(i => i != item.id);
              setSelectedCheckboxIndex(newInputValue);

              if (!newInputValue.length) {
                setDisabledBtn(true);
              }
            } else {
              setSelectedCheckboxIndex([...selectedCheckboxIndex, item.id]);
            }

            if (inputValue) {
              if (inputValue.includes(e.target.value)) {
                setInputValue(inputValue.filter(i => i !== e.target.value ));
                setInputText(inputText.filter(i => i !== item.value ));
              } else {
                setInputValue([...inputValue, e.target.value]);
                setInputText([...inputText, item.value]);
              }
            } else {
              setInputValue([e.target.value]);
              setInputText([item.value]);
            }
          }}
        />
        {item.value}
      </Label>
    )
  };

  const renderButton = (item, index) => {
    return (
      <Button
        className={(selectedButtonIndex.includes(item.id) || selectedItemIndex === index) ? 'm-2 whiteBtn active' : 'm-2 whiteBtn'}
        title={item.value}
        disabled={disabledInputs}
        key={`btn_${id}_${item.id}`}
        onClick={() => {
          setInputValue([item.id]);
          setInputText(item.value);
          setSelectedItemIndex(index);
          saveQuestion(id, [item.id], item.value);
        }}
      />
    );
  };

  const renderText = () => {
    return <input
      className='mt-2'
      type="text"
      id={id}
      value={inputText}
      disabled={disabledInputs}
      onChange={(e) => {
        setInputValue(e.target.value);
        setInputText(e.target.value);
      }}
    />
  };

  const renderDropdown = (items) => {
    const selected = selectedDropdownIndex || (answer && answer.id) ? answer.id : '' ;

    return (
      <Label className={''}>
        <select
          value={selected}
          disabled={disabledInputs}
          onChange={(e) => {
            setInputValue([e.target.value]);
            setInputText(e.target.value);
            setSelectedDropdownIndex(e.target.value);
          }}
        >
          {items.map(el => {
            return <option key={`opt_${el.id}`} value={el.id}>{el.value}</option>
          })}
        </select>
      </Label>
    )
  };

  const handleSubmit = () => {
    if (type === 'location' || type === 'department' || type === 'dropdown') {
      saveQuestion(id, selectedDropdownIndex, selectedDropdownIndex);
    } else {
      saveQuestion(id, inputValue, inputText);
    }
  };

  return (
    <Wrapper key={`qf_${id}`}>
      {type === 'radio' && items.map((item, index) => renderRadio(item, index))}
      {type === 'checkbox' && items.map((item, index) => renderCheckbox(item, index))}
      {type === 'textbox' && renderText()}
      {(type === 'location' || type === 'department' || type === 'dropdown') && renderDropdown(items)}
      {type === 'button' && items.map((item, index) => renderButton(item, index))}
      {(!answer || !disabledInputs) && !dontShowResetBtn && type !== 'button' && <div className='flex'><Button disabled={disabledBtn} className="mt-3" title={t`Submit`} onClick={handleSubmit} /></div>}
      {(disabledInputs && !dontShowResetBtn) && <div className='flex'><Button type="secondary" className="mt-3 ml5px" title={t`Reset`} onClick={() => {
        setDisabledInputs(false);
        resetAnswer(id);

        if (type == 'checkbox') {
          setSelectedCheckboxIndex([]);
        }

        if (type == 'radio') {
          setSelectedRadioIndex([]);
        }

        if (type == 'button') {
          setSelectedButtonIndex([]);
        }

        if (type == 'checkbox' || type == 'radio' || type == 'button') {
          setSelectedItemIndex(null);
        }

        if (type == 'location' || type == 'department' || type == 'dropdown') {
          setSelectedDropdownIndex('');
        }
      }} /></div>}
    </Wrapper>
  );
};

export default GetQuestionForm;
